import React, { Fragment, useEffect, useState } from "react";
import SplitData from "../../Common/SplitData";
import { GetData, ShowData, checkEmpty } from "./Components/Services";
import Loading from "../../Common/Loading";
import { useContactUs } from "./Hooks";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Color } from "../../../Utils/styles";

function Index() {
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
  };
  const { setForm, form, loading, store } = useContactUs();

  const [state, setState] = useState(initialState);
  const Handler = () => {
    setState({ ...state, loading: true });
    GetData().then(data => {
      setState({
        loading: false,
        data: data,
      });
    });
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
    Handler();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>
          درباره ما | نیکوتن 
        </title>
        <meta name="description" content={"درباره ما"} />
      </Helmet>
      <div className="row ">
        <div className="col text-center text-white rule-head ">
          <h4>درباره سایت</h4>
        </div>
      </div>

      <div className="container mb-5">
        <div className="row justify-content-lg-center" id={"#rules"}>
          <div className={`col-lg-9 col-sm-12 `}>
            {state.loading ? (
              <Loading count={1} col={12} height={300} />
            ) : (
              <Fragment>
                {checkEmpty(state.data) ? (
                  <Fragment>
                    <div className="mb-4">
                      <h3
                        className="rules-topict mb-1"
                        id="about_us"
                        style={{ fontWeight: "500" }}
                      >
                        درباره ما
                      </h3>

                      {/* <p>{ShowData(state.data, "AboutUs")}</p> */}
                      <div
                        className="content"
                        style={{
                          fontWeight: "400",
                          textAlign: "justify",
                          margin: "0 1.5%",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: ShowData(state.data, "AboutUs"),
                        }}
                      />
                    </div>
                    <div>
                      <h3
                        className="rules-topict mb-1"
                        id="rules"
                        style={{ fontWeight: "500" }}
                      >
                        اهداف نیکوتن
                      </h3>

                      <p>
                        <SplitData data={ShowData(state.data, "Targets")} />
                      </p>
                    </div>
                  </Fragment>
                ) : (
                  <span>اطلاعات موجود نیست </span>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
      <section className="mb-5">
        <iframe
          title="uniqueTitle"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d517.3180312106057!2d58.83318190906247!3d36.258047289429925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f6d09865deb09bb%3A0x3531bc13cf8dec0!2z2b7Yp9ix2qkg2LnZhNmFINmIINmB2YbYp9mI2LHbjCDZhtuM2LTYp9io2YjYsQ!5e0!3m2!1sen!2s!4v1624260112106!5m2!1sen!2s"
          width="100%"
          height={450}
          style={{ border: 0 }}
          allowFullScreen="true"
          loading="lazy"
        ></iframe>
        <header className="sub-header d-flex justify-content-center  pb-0  my-4">
          <p
            className="h2 text-grey bg-white d-inline-block px-3 text-center"
            style={{
              color: Color.black,
              fontWeight: "500 !important",
            }}
          >
            تماس با ما
          </p>
        </header>
        <div className="col-lg-9 col-sm-12 mx-auto content-sign shadow-lg part-padding  position-relative">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <label className="w-100">
                <p className="mb-1 mt-3" style={{ fontWeight: "400" }}>
                  نام
                </p>
                <input
                  type="name"
                  className="form-control "
                  placeholder="نام"
                  style={{
                    fontSize: "14px",
                  }}
                  onChange={({ target: { value } }) => {
                    setForm({ ...form, fullname: value });
                  }}
                />
              </label>
            </div>
            <div className="col-md-6 col-sm-6">
              <label className="w-100">
                <p className="mb-1 mt-3" style={{ fontWeight: "400" }}>
                  ایمیل
                </p>
                <input
                  type="email"
                  className="form-control "
                  placeholder="ایمیل"
                  style={{ textAlign: "right", fontSize: "14px" }}
                  onChange={({ target: { value } }) => {
                    setForm({ ...form, email: value });
                  }}
                />
              </label>
            </div>
          </div>
          <div className="col-lg-12 content-input2">
            <label className="w-100">
              <p className="mb-1 mt-3" style={{ fontWeight: "400" }}>
                متن پیام یا نظر شما
              </p>
              <textarea
                className="form-control content-input2 mt-0"
                placeholder="چیزی بنویسید"
                style={{ fontSize: "14px" }}
                rows={3}
                defaultValue={""}
                onChange={({ target: { value } }) => {
                  setForm({ ...form, message: value });
                }}
              />
            </label>
          </div>
          <div className="col-lg-12">
            <buttom
              id="contact_us"
              className="btn btn-orange my-3"
              onClick={store}
            >
              {loading.btn ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "ارسال"
              )}
            </buttom>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default Index;
